import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {NotificationComponent} from '@rsp/shared/component/notification/notification.component';


export interface INotification {
  text: string;
  subText?: string;
  icon: string;
}

@Injectable({providedIn: 'root'})
export class NotificationService {


  constructor(public snackBar: MatSnackBar) {

  }

  public ok(text: string, subText?: string) {
    this.snackBar.openFromComponent(NotificationComponent, {
      data: {
        text: text,
        subText: subText,
        icon: 'info'
      },
      duration: 3000,
      verticalPosition: 'top',
      panelClass: ['ok-notification']
    });
  }

  public err(text: string, subText?: string) {
    this.snackBar.openFromComponent(NotificationComponent, {
      data: {
        text: text,
        subText: subText,
        icon: 'error'
      },
      duration: 3000,
      verticalPosition: 'top',
      panelClass: ['error-notification']
    });
  }


}
